(function() {

  // ── Image fixes ──────────────────────────────────────────────────────────
  function fixJdgmImg(img) {
    if (!img || img.dataset.jdgmFixed) return;
    img.dataset.jdgmFixed = '1';

    // Resize via CDN URL params
    var src = img.getAttribute('src') || '';
    if (src.indexOf('cdn.shopify.com') > -1 && src.indexOf('width=') === -1) {
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    } else if (src.indexOf('judgeme.imgix.net') > -1) {
      img.src = src.replace(/([?&])w=\d+/, '$1w=400');
    }

    // Alt text from reviewer name + review snippet
    if (!img.alt || !img.alt.trim()) {
      var card = img.closest('[data-review-id]');
      var name = card && card.querySelector('.jdgm-reviewer-name');
      var text = card && card.querySelector('.jdgm-text p');
      var nameStr = name ? name.textContent.trim() : '';
      var textStr = text ? text.textContent.trim().substring(0, 80) : '';
      if (nameStr && textStr) {
        img.alt = 'Slapco review photo by ' + nameStr + ': ' + textStr;
      } else if (nameStr) {
        img.alt = 'Slapco review photo by ' + nameStr;
      } else if (textStr) {
        img.alt = 'Slapco review photo: ' + textStr;
      } else {
        img.alt = 'Slapco review photo';
      }
    }

    img.loading = 'lazy';
  }

  // ── Arrow accessibility fix ───────────────────────────────────────────────
  function fixJdgmArrows() {
    document.querySelectorAll('button.jdgm-arrow').forEach(function(btn) {
      if (btn.getAttribute('aria-label')) return;
      var path = btn.querySelector('path');
      var d = path ? path.getAttribute('d') : '';
      var firstX = parseInt((d.match(/^M(\d+)/) || [])[1], 10);
      // Left chevron (firstX >= 10) = Previous, right chevron = Next
      btn.setAttribute('aria-label', firstX >= 10 ? 'Previous reviews' : 'Next reviews');
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function processAll() {
    document.querySelectorAll('[class*="jdgm"] img').forEach(fixJdgmImg);
    fixJdgmArrows();
  }

  function init() {
    processAll();
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'IMG' && n.closest('[class*="jdgm"]')) fixJdgmImg(n);
          n.querySelectorAll('[class*="jdgm"] img').forEach(fixJdgmImg);
          // Re-check arrows in case carousel re-renders
          if (n.querySelector && n.querySelector('button.jdgm-arrow')) fixJdgmArrows();
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
